import { css } from 'styled-components';

// Constants
import {
	FONT_FAMILY, WEIGHTS, SPACE,
} from './constants';

import {
	autoElement,
	fluidElement, fontSize, fontWeight, mobileOptions,
} from './props';

const standardSize = css`
	width: 140px;
	padding: 0px ${SPACE.SMEDIUM}px;
	height: 40px;
`;

const smallSize = css`
	max-width: 100%;
	padding: ${SPACE.XSMALL}px ${SPACE.SMEDIUM}px;
	height: auto;
`;

const largeSize = css`
	width: 180px;
	padding: 0;
	height: 50px;
`;

const base = css`
	display: flex;
	justify-content: center;
	align-items: center;
	${FONT_FAMILY.proximaNovaSoft};
	font-weight: ${WEIGHTS.SEMI_BOLD};
	${mobileOptions};
	${autoElement};
	${fluidElement};
	${fontSize};
	${fontWeight};
	transition: all 0.3s ease;
	border-radius: 4px;
	color: white;
	
	${(props) => {
		if (props.size) {
			if (props.size === 'large') {
				return largeSize;
			}
			if (props.size === 'small') {
				return smallSize;
			}
		}
		return standardSize;
	}}
	
	&:hover {
		cursor: pointer;
		transform: scale(1.03);
	}
`;

export const buttonFill = css`
	${base};
	${(props) => {
		if (props.background) {
			if (props.gradient) {
				return `background: linear-gradient(0deg, ${props.gradient} 0%, ${props.background} 100%)`;
			}
			return `background: ${props.background};`;
		}
		return null;
	}}
`;

export const buttonOutline = css`
	${base};
	border: 1px solid ${props => props.border_color};
	color: ${props => props.border_color};
`;
